class BookingPanel extends Panel {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkForSuccess();
  }

  checkForSuccess() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true') {
      if (location.hash && location.hash === '#booking_form') {
        panelManager.dispatch('OPEN_BOOKING');
      }
    }
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    this.preselectLocation(triggerElement);
    this.activate();
    this.ensureHeaderClass();

    if (previousState === 'idle') {
      actions.openRightBottomNav().then(() => {
        window.trapFocus(this, this.defaultFocus, triggerElement);
      });
    } else if (previousState == 'shopActive') {
      drawerElement.classList.add('-translate-x-full');
      waitForTransitionEnd(drawerElement).then(() => {
        drawerElement.classList.remove('transition-all');
        requestAnimationFrame(() => {
          drawerElement.className =
            'absolute inset-y-0 w-full translate-x-full drawer-inner z-75 ' + ' md:right-0 bg-white md:w-25';
          setTimeout(() => {
            previousPanel.deactivate();
            drawerElement.classList.add('transition-all', 'duration-600');
            requestAnimationFrame(() => {
              drawerElement.classList.remove('translate-x-full');
              drawerElement.addEventListener('mouseover', mouseOverDrawer);
              waitForTransitionEnd(drawerElement);
            });
          }, 32);
        });
      });
    } else {
      if (previousPanel) {
        window.trapFocus(this, this.defaultFocus, triggerElement);
        previousPanel.deactivate();
      }
    }
  }

  preselectLocation(triggerElement) {
    const bookingLocation = triggerElement?.dataset.bookingLocation;
    if (!bookingLocation) return;

    const locationInput = Array.from(this.querySelectorAll('input[name="contact[location]"]')).find((input) =>
      input.id.split('booking-')[1]?.includes(bookingLocation),
    );

    if (!locationInput) return;

    locationInput.checked = true;
    locationInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  ensureHeaderClass() {
    const header = document.querySelector('header');
    const expandedHeader = document.querySelector('expanded-header');

    if (!this.classList.contains('hidden')) {
      if (header) {
        header.classList.remove('desktop-drawer-open');
      }

      if (expandedHeader) {
        const root = expandedHeader.shadowRoot || expandedHeader;
        const buttons = root.querySelectorAll('button');
        buttons.forEach((btn) => {
          if (btn.className.includes('!text-black')) {
            btn.className = btn.className.replace(/\!text-black/g, '').trim();
          }
        });
      }
    }
  }
}

customElements.define('booking-panel', BookingPanel);
